export type AiMarketState =
  | "no_brand"
  | "competitor_occupied"
  | "co_present"
  | "brand_owned";

const providers = ["aio", "gemini", "chatgpt"] as const;

export function formatAiMarketState(
  marketState: AiMarketState | null | undefined,
  _competitorCount: number | null | undefined
): string | null {
  if (marketState === "competitor_occupied") return "競品佔位";
  if (marketState === "co_present") return "共同佔位";
  if (marketState === "brand_owned") return "原木香佔位";
  if (marketState === "no_brand") return "無品牌佔位";
  return null;
}

export function getKeywordMarketPriority(keyword: any): number {
  const states = providers.map(provider => keyword?.aiSignals?.[provider]?.marketState);
  return states.includes("competitor_occupied") ? 0 : 1;
}

export function keywordMatchesMarketState(
  keyword: any,
  marketState: AiMarketState | "all"
): boolean {
  if (marketState === "all") return true;
  return providers.some(
    provider => keyword?.aiSignals?.[provider]?.marketState === marketState
  );
}
